import TodoLayout from "../../components/TodoList/TodoLayout";

const TodoListPage = () => {
    return (
        <div>
            <TodoLayout />
        </div>
    );
};

export default TodoListPage;
